import { applyMask } from 'components/MaskedOutput';
import { logError } from 'errors/errorHandler';

import { enFiscalDocumentsActions } from './reducers';
import CDFServices from './services';
import CDFTypes from './types';

import type { ICDFList, IFilterParams } from './interfaces';
import type IActionType from 'store/_utils/interfaces/IActionType';

let listReq: number = null;

export const getList = (params: IFilterParams) =>
  CDFTypes.list.createAction(null, (actionType: IActionType) => {
    return async (dispatch: any) => {
      try {
        const currentReq = (listReq = Date.now());

        dispatch({ type: actionType.request });
        let { data } = await CDFServices.getList(params);

        if (listReq !== currentReq) {
          return; //Uma nova requisição foi iniciada
        }

        if (data && Array.isArray(data)) {
          const key = params.type === 'received_eduzz' ? 'customer_origin' : 'destination_customer';

          data.forEach((data) => {
            (data.list || []).forEach((item: any) => {
              item.display = `${data.type} - ${item[key].name} - ${applyMask(item[key].document_number, 'cpfCnpj')}`;
            });

            return data;
          });
        }

        dispatch({ type: actionType.success, payload: data });
      } catch (error) {
        dispatch({ type: actionType.error, error });
        logError(error);
      }
    };
  });

export function showDetails(model: ICDFList[0]['list'][0]) {
  return async (dispatch: any) => {
    dispatch({ type: enFiscalDocumentsActions.details, data: model });

    await Promise.all([loadItems(model.id)(dispatch), loadFiles(model.id)(dispatch)]);
  };
}

let itemsReq: number = null;
export function loadItems(id: number) {
  return async (dispatch: any) => {
    try {
      const currentReq = (itemsReq = Date.now());

      dispatch({ type: enFiscalDocumentsActions.detailsItemRequest });
      const {
        data: { data },
      } = await CDFServices.getDetailsItems(id);

      if (itemsReq !== currentReq) return; //Uma nova requisição foi iniciada
      dispatch({ type: enFiscalDocumentsActions.detailsItemSuccess, data });
    } catch (error) {
      dispatch({ type: enFiscalDocumentsActions.detailsItemError, error });
      logError(error);
    }
  };
}

let filesReq: number = null;
export function loadFiles(id: number) {
  return async (dispatch: any) => {
    try {
      const currentReq = (filesReq = Date.now());

      dispatch({ type: enFiscalDocumentsActions.detailsFilesRequest });
      const {
        data: { data },
      } = await CDFServices.getDetailsFiles(id);

      if (filesReq !== currentReq) return; //Uma nova requisição foi iniciada
      dispatch({ type: enFiscalDocumentsActions.detailsFilesSuccess, data });
    } catch (error) {
      dispatch({ type: enFiscalDocumentsActions.detailsFilesError, error });
      logError(error);
    }
  };
}

export function closeDetails() {
  return async (dispatch: any) => {
    dispatch({ type: enFiscalDocumentsActions.details, data: null });
  };
}

export const loadUrlDownload = (id: number) => CDFTypes.urlDownload.createAction(() => CDFServices.urlDownload(id));
export const exportCDF = (params: IFilterParams) => CDFTypes.export.createAction(() => CDFServices.export(params));
